import { API_PATHS } from "../constants/api-paths";
import { type IResponse, encryptedRequest } from "../core/api.client";

interface IProfInsertApiRequest {
  mobileNo: string;
  custId?: string;
  journeyName: string; // icors or default
  custType?: string;
  offerId?: string; // icors
  offerName?: string; // icors
  loanAmt?: string;
  offerAmt?: string; // icors
  tenureInMon?: string;
  loanVariant?: string;
  initialTenor?: string;
  subsequentTenor?: string;
  roi?: string;
  hybridEmiAmt?: string;
  droplineEmiAmt?: string;
  emiAmt?: string;
  actualEmiAmt?: string;
  maxLoanVariant?: string;
  maxLoanTenor?: string;
  // addOnProd type is pending finalisation from the b2c addon API – using unknown[] as safe placeholder
  // biome-ignore lint/suspicious/noExplicitAny: will change it later
  addOnProd?: any;
  profession?: string;
  subProfession?: string;
  appId?: string;
  appVersion?: string;
}

interface IProfInsertApiResponse {
  id: string;
  eventCode: string;
  journeyName: string;
}

export async function postProfInsertApi(
  requestBody: IProfInsertApiRequest
): Promise<IResponse<IProfInsertApiResponse>> {
  const response = await encryptedRequest<IProfInsertApiResponse, IProfInsertApiRequest>({
    method: "POST",
    url: API_PATHS.profInsert,
    data: { appVersion: requestBody.appVersion ?? "v4", ...requestBody },
  });

  if (response.statusCode !== 90) {
    throw new Error(response.message);
  }

  return response;
}
